import React, { useEffect, useState } from 'react';
import { trackingConfig, consentState, setConsent } from '../lib/tracking';

/**
 * Only appears when Admin has chosen a consent mode other than "none".
 * Until it is accepted, the gated destinations are never loaded.
 */
export const ConsentBanner = () => {
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState('none');

  useEffect(() => {
    const t = setTimeout(() => {
      const cfg = trackingConfig();
      const m = cfg?.consent_mode || 'none';
      setMode(m);
      setShow(m !== 'none' && consentState() === 'unset');
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  const decide = (v) => { setConsent(v); setShow(false); };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 sm:p-6" data-testid="consent-banner">
      <div className="max-w-3xl mx-auto bg-[#1B1815] text-[#F6F3EE] border border-[#B08D57]/40 px-5 py-4 sm:px-7 sm:py-5
                      flex flex-col sm:flex-row sm:items-center gap-4 shadow-2xl">
        <div className="flex-1 min-w-0">
          <p className="text-[9px] uppercase tracking-[0.24em] text-[#B08D57] mb-1.5">Your privacy</p>
          <p className="text-[13px] leading-relaxed text-[#F6F3EE]/80">
            {mode === 'all'
              ? 'We use cookies to understand how the maison is browsed and to measure our campaigns.'
              : 'We measure our own site straight away. Advertising cookies wait for your permission.'}
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => decide('declined')} data-testid="consent-decline"
            className="text-[10px] uppercase tracking-[0.18em] px-4 py-2.5 border border-[#F6F3EE]/25
                       hover:border-[#F6F3EE]/60 transition-colors">
            Decline
          </button>
          <button onClick={() => decide('accepted')} data-testid="consent-accept"
            className="text-[10px] uppercase tracking-[0.18em] px-5 py-2.5 bg-[#B08D57] text-[#1B1815]
                       hover:bg-[#c39d61] transition-colors">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
